/**
 *
 */

import DOMPurify from "dompurify";

export function renderSafeHtml(tpl: string, attrs: Record<string, any>) {
    const html = tpl.replace(/\{([^}]+)\}/g, (_, key) => {
        const v = attrs?.[key] ?? "";
        const div = document.createElement("div");
        div.textContent = String(v);
        return div.innerHTML;
    });
    return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}
